import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import withFieldActions from '../withFieldActions';
import Checkbox from '../../../FormFields/Checkbox';
import ConfigService from '../../../../Services/api/Config';

export class TenantIdWidget extends React.PureComponent {
  renderConfig = (internalField, changeFieldValue, changeFieldError) => {
    const {api} = this.props;
    return (
      <div className="Widget_Form_Config">
        <InputText
          label="Label"
          required
          value={api ? api.getFieldsVerbiage(internalField, 'label') : internalField.label}
          onChange={(v) => changeFieldValue('label', v)}
          error={internalField.errors['label']}
          onError={(error) => changeFieldError('label', error)}
        />
        <div className="InputCheckboxesWrapper">
          <Checkbox
            onChange={(v) => changeFieldValue('lockDDR', v)}
            label="Lock in DDR"
            checked={internalField.lockDDR}
            className="InputCheckbox_Block"
          />
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, api } = this.props;
    const styleDescription = {
      color: ConfigService.getColor('secondaryColor')
    };
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfig),
      formTitle: 'Tenant Id',
      className: 'WrapperWidget_Inline'
    };
    return (
      <WrapperWidget {...props}>
        <div className="TenantIdWidget">
          <div className="Widget_Label">
            <span className="Widget_Label_Description" style={styleDescription}>
              {value || (api ? api.getFieldsVerbiage(field, 'description') : field.description)}
            </span>
          </div>
        </div>
      </WrapperWidget>
    );
  }
}

export const TenantIdWidgetEditable = withFieldActions(TenantIdWidget);
